module.exports = __webpack_public_path__ + "img/appstore.fb4f3f85.png";